import { HTTP } from "@/utils/http-common"

export default {
  dashboard_counters: function($, id) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/perfumist/brand/${id}/dashboard_counters/`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },
  unvalidated_products: function($, id) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/perfumist/brand/${id}/unvalidated_products/`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },
  resendInvitation: function(email) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/perfumist/resend-invitation/`, { email: email })
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },
  activateUser: function(id) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/perfumist/back-office/admin/users/${id}/activate/`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },
  resetUserPassword: function(id) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/perfumist/back-office/admin/users/${id}/reset-password/`)
        .then(response => {
          console.log(response.data)
          resolve(response.data)
        })
        .catch(err => {
          return reject(err)
        })
    })
  }
}
